/**
 * Query options of an audited, throttled admin read of personal data (the API
 * logs who read what): no automatic retry or refetch on focus, and the result
 * leaves memory 30 seconds after its last use. Spread into `useQuery`.
 */
export const AUDITED_READ_OPTIONS = {
  retry: false,
  staleTime: 30_000,
  gcTime: 30_000,
  refetchOnWindowFocus: false,
} as const;
